import { svg } from 'lit';
export const scan16Svg = svg `
<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.5 8H14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.5 11V12C14.5 13.1046 13.6046 14 12.5 14H11.5M14.5 5V4C14.5 2.89543 13.6046 2 12.5 2H11.5M5.5 2H4.5C3.39543 2 2.5 2.89543 2.5 4V5M2.5 11V12C2.5 13.1046 3.39543 14 4.5 14H5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
//# sourceMappingURL=scan_16.svg.js.map